"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttackTypeToAttribute = void 0;
const enums_1 = require("../enums");
exports.AttackTypeToAttribute = {
    'magic': enums_1.AttributeType.Focus,
    'melee': enums_1.AttributeType.Power,
    'ranged': enums_1.AttributeType.Power,
};
